import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import {CTA} from "../../general/Button";
import config from "../../../config/channels";
import useSiteContext from "../../../contexts/site/useSiteContext";
import {useNavigate} from "react-router-dom";
import TinyModal from "../../general/TinyModal";

type ChannelClosedWelcomeModalProps = {
    channel: string;
    show: boolean;
    singleSiteAndChannel: boolean;
    onHide: () => void;
};

const ChannelClosedWelcomeModal = ({
    channel,
    show,
    singleSiteAndChannel,
    onHide,
}: ChannelClosedWelcomeModalProps) => {

    const navigate = useNavigate();
    const siteContext = useSiteContext();


    useEffect(() => {
        document.getElementById('closed-modal')?.classList.add('anim-enter');

        return () => {
            document.getElementById('closed-modal')?.classList.remove('anim-enter');
        };
    }, [show]);

    const backButtonClick = () => {
        if ( siteContext.channel === config.dineIn.name ) {
            navigate(`/${config.dineIn.handle}`);
        } else if ( siteContext.channel === config.delivery.name || siteContext.channel === config.catering.name || siteContext.channel === config.venues.name ) {
            localStorage.removeItem('postcode');
            localStorage.removeItem('delivery-venue');
            navigate(`/`);
        } else {
            navigate(`/collection`);
        }
    }

    const renderFooter = () => (
        <>
            { !singleSiteAndChannel && (
                <CTA secondary buddies
                     onClick={() => backButtonClick()}
                >
                    <span>Go back</span>
                </CTA>
            )}
            <CTA buddies
                 onClick={onHide}>
                <span>View menu</span>
            </CTA>
        </>
    )

    return (
        <TinyModal
            show={show}
            onHide={onHide}
            header="Ordering unavailable"
            footer={renderFooter()}
            modalID={'closed-modal'}
        >
           <>
               <p>This location is not currently accepting orders. View the menu anyway?</p>
           </>
        </TinyModal>
    );
};

export default ChannelClosedWelcomeModal;
